import { render, staticRenderFns } from "./orderSystem.vue?vue&type=template&id=242f077e&scoped=true"
import script from "./orderSystem.vue?vue&type=script&lang=js"
export * from "./orderSystem.vue?vue&type=script&lang=js"
import style0 from "./orderSystem.vue?vue&type=style&index=0&id=242f077e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f077e",
  null
  
)

export default component.exports